import { connect } from 'react-redux'

import { gotoPage } from '../redux/modules/search/actions'
import { generateSearchURL } from '../redux/modules/search/selectors'

import Pagination from '../components/Pagination'

const mapStateToProps = (state) => ({
  generateSearchURL: generateSearchURL.bind(null, state.search),
  page: state.search.pagination.page,
  pages: state.search.pagination.pages,
  pageResultCount: state.search.results.length,
  totalResultCount: state.search.pagination.count,
})

const actionCreators = { gotoPage }

export default connect(mapStateToProps, actionCreators)(Pagination)



// WEBPACK FOOTER //
// ./src/containers/Pagination.js